import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'
import { NavLink } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
	crumbInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	crumb: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: 'bold',
		textDecoration: 'none',
		color: '#3B0275',
		marginRight: 5,
		opacity: 0.6
	},
	selectedCrumb: {
		fontWeight: 800,
		fontSize: '16px',
		lineHeight: '22px',
		color: theme.palette.primary.main,
		opacity: 1,
		textTransform: 'uppercase'
	}
}))

const SettingsBreadCrumbs = (props) => {
	const { selectedFacility, location, roles } = props
	const classes = useStyles()

	const getCrumb = () => {
		if (location && location.pathname.includes('Home'))
			return (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
					Grooming Schedule
				</NavLink>
			)

		if (location && location.pathname.includes('Assignment')) {
			return (
				<>
					<NavLink className={clsx([classes.crumb])} to={`/facilities/${
					selectedFacility ? selectedFacility._id : null
				}/groomingCalendar`}>
						Grooming Calendar /
					</NavLink>
					<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
						Grooming Assignment
					</NavLink>
				</>

			)
		}	
		if (location && location.pathname.includes('Calendar'))
			return (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
					Grooming Calendar
				</NavLink>
			)
	}

	const isGroomer = roles.length === 1 && roles.includes('Groomer')

	return (
		<div className={classes.crumbInt}>
			<NavLink
				className={classes.crumb}
				to={isGroomer ? `/facilities/${selectedFacility ? selectedFacility._id : null}/groomingHome` : `/facilities/${selectedFacility ? selectedFacility._id : null}/schedule`}>
				Home /
			</NavLink>

			<NavLink
				className={classes.crumb}
				to={`/facilities/${
					selectedFacility ? selectedFacility._id : null
				}/groomingHome`}>
				Grooming /
			</NavLink>

			{getCrumb()}
		</div>
	)
}

export default SettingsBreadCrumbs
